import Manufacturers from './Manufacturers'

export default Manufacturers;


// WEBPACK FOOTER //
// ./src/components/Query/Manufacturers/index.ts